'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SpinnerUtility = {
  spinner: null,
  parent: 'body',
  stopSpinner: function stopSpinner() {
    var spinner = this.getSpinner();
    if (spinner) {
      spinner.style.display = "none";
    }
  },
  getSpinner: function getSpinner() {
    if (!this.spinner) {
      this.spinnerID = this.spinnerID ? this.spinnerID : 'loadingIndicator';
      this.spinner = document.getElementById(this.spinnerID);
    }
    return this.spinner;
  }
};

exports.default = SpinnerUtility;
var spinner = SpinnerUtility.spinner,
    parent = SpinnerUtility.parent,
    triggerSpinner = SpinnerUtility.triggerSpinner,
    stopSpinner = SpinnerUtility.stopSpinner,
    getSpinner = SpinnerUtility.getSpinner;
exports.spinner = spinner;
exports.parent = parent;
exports.triggerSpinner = triggerSpinner;
exports.stopSpinner = stopSpinner;
exports.getSpinner = getSpinner;